// **直播广场接口列表**

import base from '../base.js'; // 导入接口域名列表
import axios from '../http.js'; // 导入http中创建的axios实例

const bus = {
    // 热力图
    getRoomsHeatMap (params) {
        return axios.get(`${base.bds}/dy/getroomsheatmap`, {
            params: params
        });
    },
    // 文件夹账号对比图
    getCompaial(params) {
        return axios.get(`${base.bds}/dy/compaialfollowroom`, {
            params: params
        });
    },
    // 主播历史对比图
    getCompaialHistory(params) {
        return axios.get(`${base.bds}/dy/comparesingleauthorroomview`, {
            params: params
        });
    },
    // 主播授权历史对比图
    getCompaialHistoryItem(params) {
        return axios.get(`${base.bds}/oauth/creator_room_list`, {
            params: params
        });
    },
    // 流量结构
    getRiverHistory(params) {
        return axios.get(`${base.bds}/dy/roomflowdataanalyze`, {
            params: params
        });
    },
    // 流量来源分析
    getroomflowsource(params) {
        return axios.get(`${base.bds}/dy/getroomflowsource`, {
            params: params
        });
    },
    // 占比图
    getRooms (params) {
        return axios.get(`${base.bds}/dy/getrooms`, {
            params: params
        });
    },
    // 获取热力图账号列表
    getRoomList (params) {
        return axios.get(`${base.bds}/dy/getroomlist`, {
            params: params
        })
    },
    // 获取JSON文件地址
    getJSONUrl (params) {
        return axios.get(`${base.bds}/dy/getquaredata`, {
            params: params
        });
    },
    // 获取JSON数据
    getJSON (url,params) {
        return axios.get(url, {
            params: params
        });
    },
    // 广场JSON数据地址
    getRoomsJSON (params) {
        return axios.get(`${base.bds}/dy/getquaredata`, {
            params: params
        });
    },
    // 直播间信息
    roomInfo(params) {
        return axios.get(`${base.bds}/dy/roominfo/`, {
            params: params
        });
    },
    // 直播间汇总信息
    roomInfoSummary(params) {
        return axios.get(`${base.bds}/dy/roomgoodsinfoview/`, {
            params: params
        });
    },
    // 获取流量图数据
    geFlowMap(params) {
        return axios.post(`${base.bds}/dy/roomminuteinfo2/`, params);
    },
    // 获取讲解期商品数据
    getGoodsLists(params) {
        return axios.get(`${base.bds}/dy/goodanalyseview/`, {
            params: params
        });
    },
    // 获取讲解期商品数据 全量数据
    getGoodslistAll(params) {
        return axios.get(`${base.bds}/dy/getroomgoodsslicelist/`, {
            params: params
        });
    },
    // 获取商品列表数据
    getGoodslist(params) {
        return axios.get(`${base.bds}/dy/goodslistsflow/`, {
            params: params
        });
    },
    // 获取商品详情
    getGoods(params) {
        return axios.post(`${base.bds}/dy/getgoodslist/`, params);
    },
    // 历史直播列表
    getHistoryList(params) {
        return axios.get(`${base.bds}/dy/authorrooms/`, {
            params: params
        });
    },
    // 搜索主播
    searchAuthors(params) {
        return axios.post(`${base.bds}/dy/searchauthors/`, params);
    },
    // 主播信息
    authorInfo(params) {
        return axios.get(`${base.bds}/dy/getauthorroominfo/`, {
            params: params
        });
    },
    // 主播信息
    authorInfo2(params) {
        return axios.get(`${base.bds}/dy/authorinfo/`, {
            params: params
        });
    },
    // 主播最近场次图
    getSessions(params) {
        return axios.post(`${base.bds}/dy/getauthorroominfo/`, params);
    },
    // 获取充值金额
    getRecharge(params) {
        return axios.get(`${base.bds}/members/api/me_type/`, {
            params: params
        });
    },
    // 获取折扣
    getToken(params) {
        return axios.get(`${base.bds}/members/api/me_token/`, {
            params: params
        });
    },
    // 获取支付信息
    getMembers(params) {
        return axios.get(`${base.bds}/members/api/wx/`, {
            params: params
        });
    },
    // 活动列表
    activity(params) {
        return axios.get(`${base.bds}/advertising/getadvertisinginfo/`, {
            params: params
        });
    },
    // 活动历史列表
    getadvertisinghistory(params) {
        return axios.get(`${base.bds}/advertising/getadvertisinghistory/`, {
            params: params
        });
    }
}

export default bus;



// WEBPACK FOOTER //
// ./src/utils/api/bus.js